import { Component, OnInit } from '@angular/core';
import { TraceClassDecorator } from '@sentry/angular';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
    selector: 'app-login-home',
    templateUrl: './login-home.component.html',
    styleUrls: ['./login-home.component.css']
})
@TraceClassDecorator()
export class LoginHomeComponent implements OnInit {
    doctorSignUpUrl: string =
        this.utilitiesService.getBaseUrl('PORTAL_BASE_URL') +
        'referral/registration'
    otherMedicalProfessionalSignUpUrl: string =
        this.utilitiesService.getBaseUrl('PORTAL_BASE_URL') +
        'referral/registration/other-medical-professionals';

    constructor(
        private readonly utilitiesService: UtilitiesService
    ) { }

    ngOnInit(): void {
        // this.setWidthNav();
    }

    open_doctor_refferal() {
        window.open(this.doctorSignUpUrl, '_blank');
    }

    open_otherMedicalProf_refferal() {
        window.open(this.otherMedicalProfessionalSignUpUrl, '_blank');
    }
}
